import { useMemo } from "react";
import { trpc } from "../trpc";
import { keepPreviousData } from "@tanstack/react-query";

export interface ChabotUser {
  id: string;
  chatbotsCreatorId: string | undefined;
  name: string;
  email?: string;
  isOwner: boolean;
  avatarUrl?: string;
}

interface Input {
  ownerId?: number;
  userSearch?: string;
  enabled?: boolean;
}

export function useChatbotAccountMembers({
  ownerId,
  userSearch,
  enabled = true,
}: Input) {
  const { data, isLoading, error, isError } =
    trpc.chatbot.accountMembers.useQuery(
      { userSearch },
      { placeholderData: keepPreviousData, enabled },
    );

  const users: ChabotUser[] = useMemo(() => {
    return (data || []).map((member) => {
      return {
        id: member.zapierId?.toString() || "",
        chatbotsCreatorId: member.chatbotsCreatorId || undefined,
        name: member.fullName || "",
        email: member.email,
        photoUrl: member.photoUrl,
        isOwner: member.zapierId === ownerId,
      };
    });
  }, [data, ownerId]);

  return {
    users,
    isLoading,
    error,
    isError,
  };
}
